import { useEffect } from 'react';

import { useIsOfferLocked } from '@/hooks/use-is-offer-locked';
import { useUser } from '@/hooks/use-user';
import { useDealContext } from '@/lib/contexts/deal.context';
import { ActorRole } from '@/lib/graphql/generated/graphql';
import {
  hideTawk,
  loadTawk,
  setTawkAttributes,
  showTawk,
} from '@/lib/utils/load-tawk';

export function TawkChat() {
  const user = useUser();
  const isLocked = useIsOfferLocked();
  const { deal } = useDealContext();

  const shouldShow = user?.role === ActorRole.Brand && !isLocked;

  const email = user?.providerUser.email;
  const name = user?.providerUser.name ?? email;

  const dealId = deal.id;
  const brandId = deal.brandId;
  const dealName = deal.hubspotInfos.dealName;

  useEffect(() => {
    if (!dealName || !name || !email) return;

    if (!shouldShow) {
      hideTawk();
      return;
    }

    loadTawk({
      name: name ?? undefined,
      email: email ?? undefined,
    });
    showTawk();

    const attributes: Record<string, string> = {
      'deal-id': dealId,
      'deal-name': dealName,
    };
    if (brandId) {
      attributes['brand-id'] = brandId;
    }
    setTawkAttributes(attributes);

    return () => {
      hideTawk();
    };
  }, [shouldShow, name, email, brandId, dealId, dealName]);

  return null;
}
